var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "boss-button boss-button-return",
      attrs: { type: "button" },
      on: {
        click: function ($event) {
          return _vm.$emit("back")
        },
      },
    },
    [
      _c("span", { staticClass: "boss-button-return-text" }, [
        _vm._v("\n    戻る\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }